// https://stackoverflow.com/questions/1129216/sort-array-of-objects-by-string-property-value

export function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    // Move undefined to the end
    if (a[property] === undefined) {
      return 1;
    }
    if (b[property] === undefined) {
      return -1;
    }

    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;

    return result * sortOrder;
  };
}
